import { Availability, FileReference } from "~/entities/baseEntities";

export type OnlineBanner = {
  id: string;
  orgId: string;
  code: string;
  name: string;
  active: boolean;
  order: number;

  templateIds: string[];
  siteIds: string[];
  orderTypeCodes: string[];

  appliesFrom: string | null;
  appliesUntil: string | null;
  availability: Availability[];

  desktop: BannerCreative;
  mobile: BannerCreative;
  mobileInheritsDesktop: boolean;

  dots: {
    colour: string;
    activeColour: string;
  };
  action: BannerAction;
};

/** What tapping the banner does */
export enum BannerActionType {
  None = "NONE",
  OpenProduct = "OPEN_PRODUCT",
  AddProductToOrder = "ADD_PRODUCT_TO_ORDER",
  AddVoucher = "ADD_VOUCHER",
  GoToLoyalty = "GO_TO_LOYALTY",
  OpenLink = "OPEN_LINK",
}

/** Only the field belonging to `type` is meaningful */
export type BannerAction = {
  type: BannerActionType;
  productCode: string | null;
  voucherCode: string | null;
  url: string | null;
};

/**
 * Banners are artwork only - the whole banner is the call to action, so any
 * text or button is baked into the image.
 */
export type BannerCreative = {
  show: boolean;
  backgroundColour: string;
  backgroundImage: FileReference | null;
};

/**
 * The creative to render for the current viewport, or null when the banner is
 * hidden on it. Targeting and scheduling are already applied server side.
 */
export const resolveBannerCreative = (
  banner: OnlineBanner,
  isMobile: boolean,
): BannerCreative | null => {
  if (!isMobile) {
    return banner.desktop.show ? banner.desktop : null;
  }

  if (!banner.mobile.show) {
    return null;
  }

  return banner.mobileInheritsDesktop ? banner.desktop : banner.mobile;
};
